import moment from "moment";

import Icon from "./Icon";
import LiveRate from "./LiveRate";
import ProfitLoss from "./ProfitLoss";

export default function StandingCard({ item, index, id, userType, total }) {
  // 🔹 Derived display values
  const exchangeName = (() => {
    switch (item.type) {
      case "nse":
        return "NSE";
      case "mcx":
        return "MCX";
      case "fo":
        return "OPTIONS";
      case "nse_cash":
        return "NSE-EQUITY";
      case "comex_future":
        return "COMEX";
      case "crypto_future":
        return "CRYPTO";
      case "forex_future":
        return "FOREX";
      case "us_stock":
        return "US-STOCK";
      case "sgx":
        return "SGX";
      case "index":
        return "OTHERS";
      default:
        return "--";
    }
  })();

  const expiryLabel =
    item.type === "nse_cash"
      ? "EQUITY"
      : moment(item.expiry_date).format("DD-MMM");

  // 🔹 Utility: safe rate formatting
  const formatRate = (rate) =>
    rate && !isNaN(rate)
      ? item.type === "forex_future"
        ? rate
        : parseFloat(rate).toFixed(2)
      : 0;

  // 🔹 User edit handlers

  const handleOpenEdit = (type) => {
    if (!item) return;
    switch (type) {
      case "super":
        window.user_id = item.super_id;
        window.openeditSuper?.();
        break;
      case "master":
        window.user_id = item.master_id;
        window.masterModalOpen?.();
        break;
      case "user":
        window.user_id = item.user_id;
        window.userModalOpen?.();
        break;
      default:
        break;
    }
  };

  var start = moment(item.date_created);
  var end = moment(new Date());

  //Difference in number of days
  var days = moment.duration(start.diff(end)).asDays();
  var week = moment.duration(start.diff(end)).asWeeks();
  return (
    <li
      key={item.id}
      className={`menuContainer addHight text ${
        id === index ? "selection" : ""
      }`}
    >
      <div className="menuIcon">
        <Icon symbol_id={item.symbol_id} item={item} />
      </div>

      <div className="menuExchange small">{exchangeName}</div>

      {userType === 1 && (
        <div onClick={() => handleOpenEdit("super")} className="menuExchange">
          <div className="user_id">{item.super_username}</div>
        </div>
      )}

      {(userType === 1 || userType === 2) && (
        <div onClick={() => handleOpenEdit("master")} className="menuExchange">
          <div className="user_id">{item.master_username}</div>
        </div>
      )}

      {(userType === 1 || userType === 2 || userType === 3 || userType === 5) && (
        <div onClick={() => handleOpenEdit("user")} className="menuExchange">
          <div className="user_id">{item.username}</div>
        </div>
      )}

      <div className={`menuSymbol ${item.type === "fo" ? "small" : null} `}>
        {item.symbol}
      </div>
      <div className="menuExpiry">{expiryLabel}</div>

      <div className="menuBuyPrice">
        <div
          className={`menuBuyPrice ${
            item.buy_sell === 0 ? "buytext" : "selltext"
          }`}
        >
          {item.buy_sell === 0 ? "BUY" : "SELL"}
        </div>
      </div>

      <div className="menuBuyPrice">{item.qty}</div>
      <div className="menuBuyPrice">{formatRate(item.rate)}</div>

      <div className="menuBuyPrice">
        <LiveRate symbol_id={item.symbol_id} buy_sell={item.buy_sell} />
      </div>

      <ProfitLoss
        symbol_id={item.symbol_id}
        item={item}
        total={total}
        userType={userType}
      />

      <div className={`menuBuyPrice`}>
        {parseFloat(days.toString().replace("-", "")).toFixed(0)}
      </div>
      <div className={`menuBuyPrice`}>
        {parseFloat(week.toString().replace("-", "")).toFixed(0)}
      </div>
      <div className={`menuBuyPrice`}>
        {moment(item.date_created).format("DD-MM-YYYY")}
      </div>
      <div className={`menuBuyPrice`}>{moment().format("DD-MM-YYYY")}</div>
    </li>
  );
}
